export const iconFontAwesomeBuildingsSchoolFlag = (
	<i className="fa-solid fa-school-flag"></i>
);
